import { Component } from '@angular/core';
@Component({
  selector: 'app-connected-networks',
  templateUrl: './connected-networks.component.html'
})
export class ConnectedNetworksComponent {
}
